export const SET_QUERY = 'search/SET_QUERY'
export const CLEAR_SEARCH = 'search/CLEAR_SEARCH'
export const START_SEARCH = 'search/START_SEARCH'
export const ADD_RESULTS = 'search/ADD_RESULTS'
export const END_SEARCH = 'search/END_SEARCH'
export const SHOW_RESULTS = 'search/SHOW_RESULTS'
export const HIDE_RESULTS = 'search/HIDE_RESULTS'